import { render, staticRenderFns } from "./DetailHistoryTransaction.vue?vue&type=template&id=00dd2380&scoped=true"
import script from "./DetailHistoryTransaction.vue?vue&type=script&lang=js"
export * from "./DetailHistoryTransaction.vue?vue&type=script&lang=js"
import style0 from "./DetailHistoryTransaction.vue?vue&type=style&index=0&id=00dd2380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd2380",
  null
  
)

export default component.exports